import React, { useEffect, useState } from "react";
import "./App.css";
import MainApp from "./app/MainApp";
import ReactNotification from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import AlertsHandler from "./features/Alerts";
import useDesktopSize from "./utils/hooks/useDesktopSize";
import useThemeColor from "./utils/hooks/useThemeColor";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { pl } from "date-fns/locale";
import useFakeSession from "./utils/hooks/useFakeSession";
import { useDispatch } from "react-redux";
import { getConfigurationFacility } from "./app/store/config/configActions";
import useFacility from "./utils/hooks/useFacility";
import ReactPixel from "react-facebook-pixel";
import { gaEvent, logPageView, initGA } from "./app/models/ga";
import { BIRTHDAY_RESERVATION, CALENDAR_SALE, EVENT_SALE, EXERCISE_SCHEDULE, GIFT_CARD_ACTIVE, LIMITED_TICKET_COLOR, LIMITED_TICKET_GROUP, LIMITED_TICKET_SHAPE, NEWS_PAGE, PASSES_SALE, THREE_STEP } from "./app/routes";
import CacheBuster from "react-cache-buster";
import { version, homepage } from "../package.json";
import LoadingSpinner from "./features/Loading/LoadingSpinner";

const App: React.FC = () => {
  const isProduction = process.env.NODE_ENV === "production";
  const dispatch = useDispatch();
  const facilityIds = useFacility();
  const isDesktop = useDesktopSize();
  const [url, setUrl] = useState<string>(window.location.href);
  const [link, setLink] = useState("");
  const advancedMatching = { ct: "", country: "", db: "", em: "", fn: "", ge: "", ln: "", ph: "", st: "", zp: "" };
  const options = {
    autoConfig: true,
    debug: false,
  };

  useEffect(() => {
    if (facilityIds === "273") {
      ReactPixel.init("1232725160738501", advancedMatching, options);
      initGA("G-NRHETLWQFK");
      logPageView();
    }
    if (facilityIds === "1224") {
      ReactPixel.init("913533666380507", advancedMatching, options);
      initGA("G-ZYH8HLCXHT");
      logPageView();
    }
    // JUMP WARSZAWA
    if (facilityIds === "1204") {
      ReactPixel.init("777232707357603", advancedMatching, options);
      // initGA("G-ZYH8HLCXHT")
      logPageView();
    }

    // JUMP RADOM
    if (facilityIds === "1200") {
      ReactPixel.init("1637422596662010", advancedMatching, options);
      // initGA("G-ZYH8HLCXHT")
      // logPageView()
    }

    // JUMP KIELCE
    if (facilityIds === "1227") {
      ReactPixel.init("885648790025244", advancedMatching, options);
      initGA("G-Q16RVEQD1D");
      logPageView();
    }
    if (facilityIds === "1214") {
      ReactPixel.init("1149312515622709", advancedMatching, options);
      initGA("G-DSW25QCN83");
      logPageView();
    }

    

    if (url) {
      if (url.includes("EventSaleActive")) {
        setLink(EVENT_SALE);
        sessionStorage.setItem("HomePage", link);
      }
      if (url.includes("NewsActive")) {
        setLink(NEWS_PAGE);
        sessionStorage.setItem("HomePage", link);
      }
      if (url.includes("GiftCardActive")) {
        setLink(GIFT_CARD_ACTIVE);
        sessionStorage.setItem("HomePage", link);
      }
      if (url.includes("calendarSale")) {
        setLink(CALENDAR_SALE);
        sessionStorage.setItem("HomePage", link);
      }
      if (url.includes("BirthDaysActive")) {
        setLink(BIRTHDAY_RESERVATION);
        sessionStorage.setItem("HomePage", link);
      }
      if (url.includes("PassSale")) {
        setLink(PASSES_SALE);
        sessionStorage.setItem("HomePage", link);
      }
      if (url.includes("schedule")) {
        setLink(EXERCISE_SCHEDULE);
        sessionStorage.setItem("HomePage", link);
      }
      if (url.includes("ticketsShape")) {
        setLink(LIMITED_TICKET_SHAPE);
        sessionStorage.setItem("HomePage", link);
      }
      if (url.includes("ticketsGroup")) {
        setLink(LIMITED_TICKET_GROUP);
        sessionStorage.setItem("HomePage", link);
      }
      if (url.includes("ticketsColor")) {
        setLink(LIMITED_TICKET_COLOR);
        sessionStorage.setItem("HomePage", link);
      }
    }
  }, [facilityIds]);

  useThemeColor();
  useFakeSession();

  useEffect(() => {
    if (Boolean(facilityIds)) {
      dispatch(getConfigurationFacility(facilityIds));
    }
  }, [facilityIds]);

  return (
    <CacheBuster
      currentVersion={version}
      isEnabled={isProduction}
      isVerboseMode={false}
      loadingComponent={<LoadingSpinner />}
      metaFileDirectory={`.${homepage}`}
    >
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={pl}>
        <ReactNotification isMobile={!isDesktop} />
        <AlertsHandler />
        <MainApp />
      </MuiPickersUtilsProvider>
    </CacheBuster>
  );
};

export default App;
